module.exports = require('react-fast-compare')
